
<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Transaction History</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Transaction History</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
        <div class="container-fluid">
          <div class="card" id="EWTrxHistory">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <form @submit.prevent="handleSubmission()" method="POST" novalidate>
              <div class="card-header">
                <h3 class="card-title" v-if="!is_edit">Create</h3>
                <h3 class="card-title" v-if="is_edit">Edit</h3>
                <div class="card-tools">
                  <router-link class="btn btn-info" :to="{name: 'EWTrxHistoryList'}"><i class="fas fa-list"></i> List
                  </router-link>
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                    <div class="col-8">


            <div class="form-group required" >
              <label class="control-label">Sender User</label>
              <input type="text" id="sender_user_id" name="sender_user_id"
                     v-bind:class="{'has-error' : errors.has('sender_user_id')}"
                     v-validate="'required'"
                     v-model="value.sender_user_id" class="form-control sender_user_id"
                     placeholder="Sender User">
              <div class="help text-danger" v-show="errors.has('sender_user_id')">
                {{ errors.first("sender_user_id") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Receiver User</label>
              <input type="text" id="receiver_user_id" name="receiver_user_id"
                     v-bind:class="{'has-error' : errors.has('receiver_user_id')}"
                     v-validate="'required'"
                     v-model="value.receiver_user_id" class="form-control receiver_user_id"
                     placeholder="Receiver User">
              <div class="help text-danger" v-show="errors.has('receiver_user_id')">
                {{ errors.first("receiver_user_id") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Trx Activity Type</label>
              <input type="text" id="trx_activity_type_id" name="trx_activity_type_id"
                     v-bind:class="{'has-error' : errors.has('trx_activity_type_id')}"
                     v-validate="'required'"
                     v-model="value.trx_activity_type_id" class="form-control trx_activity_type_id"
                     placeholder="Trx Activity Type">
              <div class="help text-danger" v-show="errors.has('trx_activity_type_id')">
                {{ errors.first("trx_activity_type_id") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Transaction Amount</label>
              <input type="text" id="trx_amount" name="trx_amount"
                     v-bind:class="{'has-error' : errors.has('trx_amount')}"
                     v-validate="'required'"
                     v-model="value.trx_amount" class="form-control trx_amount"
                     placeholder="Transaction Amount">
              <div class="help text-danger" v-show="errors.has('trx_amount')">
                {{ errors.first("trx_amount") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Transaction Type</label>
              <select class="form-control" style="width: 100%;" v-bind:class="{'has-error' : errors.has('trx_type')}"
                      v-validate="'required'" name="trx_type" v-model="value.trx_type" id="trx_type">
                <option value="credit">credit</option><option value="debit">debit</option><option value="in">in</option><option value="out">out</option>
              </select>
              <div class="help text-danger" v-show="errors.has('trx_type')">
                {{ errors.first("trx_type") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Transaction Status</label>
              <input type="text" id="trx_status" name="trx_status"
                     v-bind:class="{'has-error' : errors.has('trx_status')}"
                     v-validate="'required'"
                     v-model="value.trx_status" class="form-control trx_status"
                     placeholder="Transaction Status">
              <div class="help text-danger" v-show="errors.has('trx_status')">
                {{ errors.first("trx_status") }}
              </div>
            </div>
            <div class="form-group " >
              <label class="control-label">Note</label>
              <textarea id="trx_note" name="trx_note"


                 v-model="value.trx_note" class="form-control trx_note"
                 placeholder="Note"
                 rows="3"></textarea>

            </div>
            <div class="form-group required" >
              <label class="control-label">Owner Id</label>
              <input type="text" id="owner_id" name="owner_id"
                     v-bind:class="{'has-error' : errors.has('owner_id')}"
                     v-validate="'required'"
                     v-model="value.owner_id" class="form-control owner_id"
                     placeholder="Owner Id">
              <div class="help text-danger" v-show="errors.has('owner_id')">
                {{ errors.first("owner_id") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Transaction UUID</label>
              <input type="text" id="trx_uuid" name="trx_uuid"
                     v-bind:class="{'has-error' : errors.has('trx_uuid')}"
                     v-validate="'required'"
                     v-model="value.trx_uuid" class="form-control trx_uuid"
                     placeholder="Transaction UUID">
              <div class="help text-danger" v-show="errors.has('trx_uuid')">
                {{ errors.first("trx_uuid") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Balance</label>
              <input type="text" id="balance" name="balance"
                     v-bind:class="{'has-error' : errors.has('balance')}"
                     v-validate="'required'"
                     v-model="value.balance" class="form-control balance"
                     placeholder="Balance">
              <div class="help text-danger" v-show="errors.has('balance')">
                {{ errors.first("balance") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Transaction Charge</label>
              <input type="text" id="trx_charge" name="trx_charge"
                     v-bind:class="{'has-error' : errors.has('trx_charge')}"
                     v-validate="'required'"
                     v-model="value.trx_charge" class="form-control trx_charge"
                     placeholder="Transaction Charge">
              <div class="help text-danger" v-show="errors.has('trx_charge')">
                {{ errors.first("trx_charge") }}
              </div>
            </div>
                    </div>
                </div>
              </div>
              <div class="card-footer">
                <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
                <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
              </div>
            </form>
          </div>
        </div>
    </section>
  </div>
</template>

<script>

//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import {DepartmentsAPI, CommonAPI} from '@/services/api'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import axios from 'axios'

export default {
  name: 'EWTrxHistoryForm',
  metaInfo: {
    title: 'Trx History | Dotlines'
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {


    },
    pre: {

    }
  }),
  methods: {



    handleSubmission () {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true
          let api_url = '/ew_trx_histories'
          let method = 'POST'
          if (_this.is_edit) {
            api_url = '/ew_trx_histories/' + _this.$route.params.id
            method = 'PUT'
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { 'Content-Type': 'application/json' },
          }).then(function (response) {
            _this.$toaster.success(response.data.message)
            _this.$router.push({'name': 'EWTrxHistoryList'})
          }).catch((errors) => {
            if (errors.response.status === 500) {
              _this.$toaster.error(errors.response.data.message)
            }
            _this.$setErrorsFromResponse(errors.response.data)
          }).finally(() => {
            _this.is_loading = false
          });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = '/ew_trx_histories/' + id
        axios.get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch((error) => {
            //console.log('error ' + error)
            reject(error)
          });
      });
    },
    async initialize () {
      this.is_loading = true
      this.params = this.$route.params

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id).then(response => {
          this.value = response.data
        }).catch((error) => {
          console.log(error.response)
        })


      }

      this.is_loading = false
    }
  },
  mounted () {
    this.initialize()
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
}
</script>

